import styled from "styled-components";
import { Link } from "react-router-dom";
import { t } from "i18next";

const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.background};
  padding: 2rem;
  font-family: "Inter Variable";
  text-align: center;
  padding-top: 140px;
`;

const NotFoundTitle = styled.h1`
  font-size: 44px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
  margin: 0;
  line-height: 1;
  font-family: "Inter Variable";
`;

const NotFoundSubtitle = styled.h2`
  font-size: 32px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.text};
  margin: 1rem 0 2rem;
  font-family: "Inter Variable";
`;

const NotFoundText = styled.p`
  font-size: 18px;
  color: ${(props) => props.theme.colors.textSecondary};
  max-width: 500px;
  margin-bottom: 2.5rem;
  line-height: 1.5;
  text-align: center;
  font-family: "Inter Variable";
`;

const HomeButton = styled(Link)`
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  text-decoration: none;
  transition: background-color 0.2s ease;
  display: inline-block;
  font-size: 14px;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.redDark};
  }

  &:focus {
    outline: 2px solid ${(props) => props.theme.colors.primaryLight};
    outline-offset: 2px;
  }
`;

const NotFoundPage = () => {
  return (
    <NotFoundContainer>
      <NotFoundTitle>404</NotFoundTitle>
      <NotFoundSubtitle>{t("notFound.title")}</NotFoundSubtitle>
      <NotFoundText>{t("notFound.description")}</NotFoundText>
      <HomeButton to="/">{t("notFound.back")}</HomeButton>
    </NotFoundContainer>
  );
};

export default NotFoundPage;
